import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button,Spinner } from 'reactstrap';
import { Tree, TreeNode as BaseTreeNode } from 'react-organizational-chart';
import { get } from "../../Services/RestAPIService";
import axios from 'axios';
import { withTranslation } from 'react-i18next';
// Wrapper for TreeNode to ensure compatibility
const TreeNode = (props) => <BaseTreeNode {...props} />;


const OrganizationChart = ({ isOpen, onClose, orgId,t }) => {
  const [orgData, setOrgData] = useState(null);
  const [loader, setLoader] = useState(true);


  useEffect(() => {
    const fetchData = async () => {
      setLoader(true)
      try {
        console.log("dd")
        const response = await get(`category/category/${orgId}/`);
        console.log(response, "dd")

        // const response = await axios.get(`https://llosana.psd2htmlx.com/api/category/categories/${orgId}/`);
        // setOrgData(response);

        // const response = await axios.get(`http://216.225.193.213:7005/api/category/category/${orgId}/`);
        setOrgData(response);
        setLoader(false)

      } catch (error) {
        console.error('Error fetching organization data:', error);

      }
    };

    if (isOpen && orgId) {
      fetchData();
    }
  }, [isOpen, orgId]);

  if (!isOpen) return null;

  const renderVideos = (videos) => (
    videos.map(video => (
      <TreeNode
        key={video.id}
        label={
          <div className="bg-white border border-gray-300 rounded-lg p-2">
            <div className="text-xs">{video.title}</div>
          </div>
        }
      />
    ))
  );

  const renderExercises = (exercises) => (
    exercises.map(exercise => (
      <TreeNode
        key={exercise.id}
        label={
          <div className="bg-white border border-gray-300 rounded-lg p-2">
            <div className="text-sm">{exercise.exercise_name}</div>
          </div>
        }
      >
        {renderVideos(exercise.videos)}
      </TreeNode>
    ))
  );

  const renderSubcategories = (subcategories) => (
    subcategories.map(subcategory => (
      <TreeNode
        key={subcategory.id}
        label={
          <div className="bg-white border border-gray-300 rounded-lg p-2">
            <div>{subcategory.name}</div>
          </div>
        }
      >
        {renderExercises(subcategory.exercises)}
      </TreeNode>
    ))
  );

  const renderTree = () => (
    <Tree
      lineWidth="2px"
      lineColor="#bbb"
      lineBorderRadius="10px"
      label={
        <div className="bg-white border border-gray-300 rounded-lg p-2">
          <div className="font-bold">{orgData.name}</div>
        </div>
      }
    >
      {renderSubcategories(orgData.subcategories)}
    </Tree>
  );

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose}>
      {t("Organization Chart")} (ID: {orgId})
      </ModalHeader>

      {!loader ? (<>

        <ModalBody className="overflow-auto max-h-[70vh]">
          {renderTree()}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={onClose}>
          {t("Close")}
          </Button>
        </ModalFooter>
      </>) : (
        <div      style={{ justifyContent:"center",alignContent:"center",display:"flex",height:"100px",flexWrap:"wrap"}}>
         <Spinner
         style={{ justifyContent:"center",alignContent:"center",display:"flex"}}
        //  type="grow"
        //  color="light"
       />
    </div>
      )}
    </Modal>
  );
};


export default withTranslation()(OrganizationChart);


